document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.marquee-content').forEach((wrapper) => {
    const track = wrapper.querySelector('.marquee-track')
    const speed = 100

    // 트랙 복제
    const clone = track.cloneNode(true)
    wrapper.appendChild(clone)

    let pos1 = 0
    let pos2
    let lastTime = performance.now()
    let trackWidth = 0

    function init(resetPosition = true) {
      const newTrackWidth = track.scrollWidth
      const widthChanged = newTrackWidth !== trackWidth
      trackWidth = newTrackWidth

      if (resetPosition || widthChanged) {
        pos1 = 0
        pos2 = trackWidth
        track.style.transform = `translateX(${pos1}px)`
        clone.style.transform = `translateX(${pos2}px)`
      }
    }

    // 이미지 로드 후 초기화
    window.addEventListener('load', () => {
      init()
      requestAnimationFrame(animate)
    })

    // 리사이즈 시: 트랙 너비가 실제로 바뀐 경우에만 위치 리셋 (스크롤 시 resize 방지)
    window.addEventListener('resize', () => {
      const prevWidth = trackWidth
      const newWidth = track.scrollWidth
      if (newWidth !== prevWidth) {
        init(true)
      }
    })

    function animate(now) {
      const delta = (now - lastTime) / 1000
      lastTime = now

      const move = speed * delta

      pos1 -= move
      pos2 -= move

      if (pos1 <= -trackWidth) {
        pos1 = pos2 + trackWidth
      }
      if (pos2 <= -trackWidth) {
        pos2 = pos1 + trackWidth
      }

      track.style.transform = `translateX(${pos1}px)`
      clone.style.transform = `translateX(${pos2}px)`

      requestAnimationFrame(animate)
    }
  })
})
